import Vue from 'vue';
import VueI18n from 'vue-i18n';
// @ts-ignore
import store from '@/store';

Vue.use(VueI18n);

function loadLocaleMessages() {
  const locales = require.context('@/locales', true, /[A-Za-z0-9-_,\s]+\.json$/i);
  const messages = {};
  locales.keys().forEach((key) => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      // @ts-ignore
      messages[locale] = locales(key);
    }
  });
  return messages;
}

function loadLocale() {
  // @ts-ignore
  // eslint-disable-next-line max-len
  const locale = store.state.app.locale ? store.state.app.locale.code : process.env.VUE_APP_I18N_LOCALE;
  return locale;
}

export default new VueI18n({
  locale: loadLocale(),
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE,
  messages: loadLocaleMessages(),
});
